import { render, staticRenderFns } from "./RaceVideoRankingPane.vue?vue&type=template&id=5508c5be&scoped=true"
import script from "./RaceVideoRankingPane.vue?vue&type=script&lang=ts"
export * from "./RaceVideoRankingPane.vue?vue&type=script&lang=ts"
import style0 from "./RaceVideoRankingPane.vue?vue&type=style&index=0&id=5508c5be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508c5be",
  null
  
)

export default component.exports